import React, { Component } from 'react';
import {AppProvider, Button, Card, Icon} from "@shopify/polaris";
import enTranslations from '@shopify/polaris/locales/en.json';
import {ChevronLeftMinor} from '@shopify/polaris-icons';
import './signup.css';
import SignupStepOne from './step_one';
import SignupStepTwo from './step_two';
import SignupStepThree from './step_three';
import {reqRegister} from "../../api/index";
import memory from '../../utils/memory';
import storage from '../../utils/storage';

export default class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 这里做了一个状态提升，子组件共享了父亲组件的state
            name:'',
            email:'',
            password:'',
            partner_type:'',
            partner_plan_of_promote:'',
            paypal_address:'',
            partner_type_option:[],
            current_step:0,
            loading:false,

            name_error:false,
            email_error:false,
            password_error:false,
            partner_type_error:false,
            partner_plan_of_promote_error:false,
            paypal_address_error:false
        }
    }

    validateion_for_step_one = () =>{
        let if_pass = 1;
        if (this.state.name === '') {
            if_pass = 0;
            this.setState({name_error:'Name is required'})
        }

        if (this.state.email === '') {
            if_pass = 0;
            this.setState({email_error:'Email is required'})
        }

        if(this.state.email !== '' && !(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(this.state.email))) {
            if_pass = 0;
            this.setState({email_error:'Email is invalid'})
        }

        if (this.state.password === '') {
            if_pass = 0;
            this.setState({password_error:'Password is required'})
        }

        if (this.state.password !== '' && this.state.password.length < 8 ) {
            if_pass = 0;
            this.setState({password_error:'Password is too short (minimum is 8 characters)'})
        }

        return if_pass;
    }

    validateion_for_step_two = () =>{
        let if_pass = 1;
        
        if (this.state.partner_type === '') {
            if_pass = 0;
            this.setState({partner_type_error:'Partner type is required'})
        }

        if (this.state.partner_plan_of_promote === '') {
            if_pass = 0;
            this.setState({partner_plan_of_promote_error:'Partner plan of promote is required'})
        }

        return if_pass;
    }

    validateion_for_step_three = () =>{
        let if_pass = 1;
        
        if (this.state.paypal_address === '') {
            if_pass = 0;
            this.setState({paypal_address_error:'Paypal address is required'})
        }

        if(this.state.paypal_address !== '' && !(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(this.state.paypal_address))) {
            if_pass = 0;
            this.setState({paypal_address_error:'Email is invalid'})
        }

        return if_pass;
    }

    signUp = () => {
        if(this.validateion_for_step_three() === 0)
        {
            return false;
        }

        this.setState({loading:true});
        
        let user_info = {
            email:this.state.email,
            name:this.state.name,
            password:this.state.password,
            partner_type:this.state.partner_type,
            partner_plan_of_promote:this.state.partner_plan_of_promote,
            paypal_address:this.state.paypal_address
        }

        reqRegister(user_info).then(
            response => {
                if (response.data.success.token !== '') {
                    user_info['token'] = response.data.success.token
                    user_info['affiliate_link'] = response.data.success.affiliate_link
                    
                    //保存全局配置文件到浏览器存储
                    let setting = response.data.success.setting
                    memory.setting = setting
                    storage.saveInfo('setting', setting)

                    //出于安全性考虑，一部分数据不存到内存里面去
                    delete user_info.password;
                    delete user_info.partner_plan_of_promote;

                    //保存用户的信息到浏览器存储
                    memory.user_info = user_info
                    storage.saveInfo('user_info', user_info)

                    this.props.history.replace('/')
                }

                this.setState({loading:false});
            }
        ).catch(
            error => {
                this.setState({loading:false});
            }
        )
    }

    nextStep = () =>{
        if(this.state.current_step < 2)
        {
            //第一步验证
            if (this.state.current_step === 0 && this.validateion_for_step_one() === 0) {
                return false;
            }

            //第一步验证
            if (this.state.current_step === 1 && this.validateion_for_step_two() === 0) {
                return false;
            }

            this.setState({current_step:this.state.current_step + 1})
        }
    }

    goback = () =>{
        if(this.state.current_step === 0)
        {
            this.props.history.replace('/login')
        }else{
            this.setState({current_step:this.state.current_step - 1})
        }
    }

    getChange = (result, name, val) => {
        this.setState({
            [name]: val
         ,[name + '_error']: false}); //如果有输入，错误验证重置
    }

    render() {

        let step;
        switch (this.state.current_step) {
            case 0:
                step = <SignupStepOne onChange={this.getChange} info={this.state}/>;
                break;
            case 1:
                step = <SignupStepTwo onChange={this.getChange} info={this.state}/>;
                break;
            case 2:
                step = <SignupStepThree onChange={this.getChange} info={this.state}/>;
                break;
            default:
                step = <SignupStepThree onChange={this.getChange} info={this.state}/>;
                break;
        }

        let signup_button;
        if(this.state.current_step === 2)
        {
            signup_button = <Button loading={this.state.loading} onClick={() => this.signUp()} primary>Enter my account</Button>
        }else
        {
            signup_button = <Button onClick={() => this.nextStep()} primary>Next</Button>
        }

        return (
            <div className="signup">
                <AppProvider i18n={enTranslations}>
                    <Card sectioned>
                        {step}

                        <hr className="signup-hr"/>

                        <div className="button-section">
                            <span className="back" onClick={() => this.goback()} ><Icon source={ChevronLeftMinor} /> Back</span><span>{signup_button}</span>
                        </div>
                    </Card>
                </AppProvider>
            </div>
        );
    }
}
